var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{staticClass:"ui-icon tw-select-none",class:[
    _vm.data.class,
    _vm.data.staticClass
  ],attrs:{"aria-hidden":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }